import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { DATA_SYNC_SOURCES, DataSyncSource } from './data-sync-source';

export function provideDataSyncSource(factory: () => DataSyncSource): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: DATA_SYNC_SOURCES, useFactory: factory, multi: true },
  ]);
}
